import * as React from 'react';
import { Page } from 'src/components/common';
import { Redirect } from 'react-router-dom';
import { Button } from 'src/components/buttons';

interface IState {
	redirect: boolean;
}

class FourOhFourPage extends React.Component<{}, IState> {
	constructor(props: any) {
		super(props);
		this.state = {
			redirect: false,
		};
	}

	componentDidMount() {
		setTimeout(
			() => this.setState({ redirect: true }),
			5000
		);
	}

	public redirect = () => {
		this.setState({ redirect: true })
	}

	public render() {
		const { redirect } = this.state;

		if (redirect) {
			return <Redirect to='/' />;
		}

		return (
			<Page title="404">
				<div className="container-fluid">
					<section className="features-1">
						<h1 className="display-1">404</h1>
						<h2>Page not found</h2>
						<p className="mt-2">Sorry, I'm not sure how you got here but this place doesn't exist. You will be redirected soon. If you are not redirected, please press the button to take you back.</p>
						<p>
							<Button className="btn-primary" onClick={this.redirect}>
								Go back
						</Button>
						</p>
					</section>
				</div>
			</Page>
		);
	}
}

export default FourOhFourPage;
